// extracted by mini-css-extract-plugin
export default {"wrapper":"Lesson_wrapper__V-Cwl","loading":"Lesson_loading__tOWqN","content":"Lesson_content__x4YHt","topLevel":"Lesson_topLevel__8UGsg","maj":"Lesson_maj__IQYSa"};